/**
 * Modal shown when the currently-active Google session doesn't match the
 * account that was used to connect Drive storage.
 */

interface AccountDivergenceModalProps {
  savedEmail: string;
  liveEmail: string;
  isWorking: boolean;
  onReconnect: () => void;
  onDisconnect: () => void;
  onDismiss: () => void;
}

export function AccountDivergenceModal(props: AccountDivergenceModalProps) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-stone-900/60 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl dark:bg-stone-900">
        <h3 className="mb-2 text-lg font-semibold text-stone-800 dark:text-stone-100">
          Google account mismatch
        </h3>
        <p className="mb-3 text-sm text-stone-600 dark:text-stone-400">
          Drive was connected as <strong className="font-mono">{props.savedEmail}</strong> but the
          active Google session is{' '}
          <strong className="font-mono">{props.liveEmail}</strong>.
        </p>
        <p className="mb-4 text-sm text-stone-600 dark:text-stone-400">
          Writes would land in the wrong Drive. Reconnect to switch to the active account, or
          disconnect to stop syncing until you fix it.
        </p>
        <div className="flex flex-wrap justify-end gap-2">
          <button
            onClick={props.onDismiss}
            disabled={props.isWorking}
            className="rounded-lg border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-stone-100 disabled:opacity-50 dark:border-stone-600 dark:text-stone-300 dark:hover:bg-stone-800"
          >
            Dismiss
          </button>
          <button
            onClick={props.onDisconnect}
            disabled={props.isWorking}
            className="rounded-lg border border-stone-300 px-3 py-1.5 text-xs font-medium text-stone-700 hover:bg-stone-100 disabled:opacity-50 dark:border-stone-600 dark:text-stone-300 dark:hover:bg-stone-800"
          >
            Disconnect
          </button>
          <button
            onClick={props.onReconnect}
            disabled={props.isWorking}
            className="rounded-lg bg-cyan-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-cyan-600 disabled:opacity-50"
          >
            Reconnect as {props.liveEmail}
          </button>
        </div>
      </div>
    </div>
  );
}
